module.exports = __webpack_public_path__ + "eb827a4ba27f0984e01140879024d951.svg";